import React from 'react';

import classnames from 'classnames';
import { map, size } from 'lodash';

import EmberFeedback from 'pages/Students/Assignments/Overview/components/EmberFeedback';
import { ReactComponent as CameraIcon } from 'pages/Students/shared/assets/camera.svg';
import { formatActiveDate } from 'utils/date';

import ImgixImage from 'components/ImgixImage';

import styles from './styles.module.scss';

const TaskWork = ({
  showImageUploadButtons,
  work,
  active,
  changeImage,
  openCameraView,
  emberDetails = null,
  isChatOpen = false,
  toggleChat = () => {}
}) => (
  <div className={styles.workContainer}>
    <div>
      {size(work) === 0 && showImageUploadButtons && (
        <div className={styles.workPlaceholder} onClick={openCameraView}>
          <CameraIcon fill="#ccc" />
        </div>
      )}

      {size(work) > 0 && (
        <div className={styles.imageContainer} style={{ position: 'relative' }}>
          <ImgixImage
            src={active.work_url}
            dimensions={{ width: 500, height: 500 }}
          />

          {/* Render EmberFeedback only if both emberDetails and isChatOpen are provided */}
          {emberDetails && isChatOpen && (
            <EmberFeedback
              emberDetails={emberDetails}
              active={active}
              open={isChatOpen}
              onClose={toggleChat}
              style={{
                position: 'absolute',
                bottom: 8,
                right: 8
              }}
            />
          )}
        </div>
      )}
    </div>

    {active && (
      <div className={styles.workBar}>
        <div className={styles.workDate}>
          {formatActiveDate({ date: active.created_at })}
        </div>
        <div className={styles.workType}>{active.type}</div>

        {size(work) > 1 && (
          <div className={styles.workPaginator}>
            {map(work, (img, index) => (
              <div
                key={img.id}
                className={classnames({
                  [styles.selected]: img.id === active.id
                })}
                onClick={() => changeImage(img)}
              >
                {index + 1}
              </div>
            ))}
          </div>
        )}
      </div>
    )}
  </div>
);

export default TaskWork;
